/**
 * @description 노무비 산출 테이블 헤더
 */
export const labor_cost_headers = [
    { text: "품번", align: "start", value: "no" },
    { text: "공종", align: "start", value: "name" },
    { text: "규격", align: "start", value: "type" },
    { text: "직종", align: "start", value: "occupation" },
    { text: "공량(M/D)", align: "start", value: "manPerDay" },
    { text: "할증율", align: "start", value: "surchargeRatio" },
    { text: "설계조정률", align: "start", value: "adjustmentRatio" },
    { text: "공량(M/H)", align: "start", value: "manPerHour" },
    { text: "단가(M/D)", align: "start", value: "unitPrice" },
    { text: "수량", align: "start", value: "quantity" },
    { text: "금액", align: "start", value: "totalAmount" },
    { text: "공정별 금액", align: "start", value: "noTotalAmount" },
];
